import React from "react";
import { Link, useLocation } from "react-router-dom";

import { Images } from "../../config";

const StudentSidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const SidebarRoutes = [
    {
      title: "Home",
      route: "/home",
      icon: Images.SidebarHome,
    },
    {
      title: "Universities",
      route: "/universities/list",
      icon: Images.Sidebaruniversities,
    },
    {
      title: "Schools",
      route: "/schools",
      icon: Images.Sidebaruniversities,
    },
    {
      title: "Meetings",
      route: "/meetings/upcoming",
      icon: Images.Sidebarmeetings,
    },
    {
      title: "Applications",
      route: "/applications",
      icon: Images.SidebarApplications,
    },
    {
      title: "Visa Information",
      route: "/visa-information",
      hoverTitle:
        "Provides details on visa requirements, application costs, processing time, required documents, and additional information for obtaining a student visa.",
      icon: Images.Sidebarvisainfo,
    },
    {
      title: "Countries",
      route: "/country",
      hoverTitle: "Country list",
      icon: Images.Sidebarvisainfo,
    },
    {
      title: "Internships",
      route: "/internships",
      hoverTitle: "Internship list",
      icon: Images.Sidebarvisainfo,
    },
    {
      title: "Students",
      route: "/students",
      icon: Images.Sidebarstudents,
    },
  ];

  return (
    <div className="sidebar">
      <Link to="/home">
        <img src={Images.SidebarLogo} className="sidebar-logo" />
      </Link>

      <div className="sidebar-items-container">
        {SidebarRoutes.map((item, index) => (
          <Link
            className={`${
              item?.route?.includes(pathname.split("/")[1])
                ? "sidebar-item-active"
                : "sidebar-item"
            } ${item?.comingSoon && "pointer-events-none"}`}
            to={item.route}
            key={index}
            title={item?.hoverTitle}
            onClick={(e) => {
              if (pathname === item.route) {
                e.preventDefault();
                window.location.reload();
              }
            }}
          >
            <div className="flex gap-4 items-center">
              <img
                src={item.icon}
                className={`${
                  item?.comingSoon ||
                  !item?.route?.includes(pathname.split("/")[1])
                    ? "opacity-50"
                    : "opacity-100"
                } sidebar-icon`}
              />
              <div className="sidebar-title">
                <div
                  className={`${
                    item?.comingSoon ? "opacity-50" : "opacity-100"
                  } text-ellipsis whitespace-nowrap`}
                >
                  {item?.title}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
export default StudentSidebar;
